<template>
<div id="app">
  <router-view></router-view>
</div>
</template>


<script>
import store from 'store'

export default {
  name: 'app',
  store: store,
  created () {
    console.log('build date: ' + process.env.BUILD_DATE)
  },
}
</script>



// WEBPACK FOOTER //
// app.vue?8b7221ce